define('util/bounds',["require", "exports", "./math"], function (require, exports, math_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.squareBounds = exports.cleanBounds = exports.expandBounds = void 0;
    // Bounds must always be at least epsilon in dimension
    var epsilon = 0.001;
    /** Expand bounds in-place from fx and fy projections */
    function expandBounds(bounds, data, fx, fy) {
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var point = data_1[_i];
            var x = fx(point);
            var y = fy(point);
            if (x < bounds.x.min)
                bounds.x.min = x;
            if (x > bounds.x.max)
                bounds.x.max = x;
            if (y < bounds.y.min)
                bounds.y.min = y;
            if (y > bounds.y.max)
                bounds.y.max = y;
        }
    }
    exports.expandBounds = expandBounds;
    /**
     * Expands bounds to fit within outer bounds
     */
    function cleanBounds(bounds, inner, outer) {
        // Expand to inner
        // bounds.x.min = min(bounds.x.min, inner.x.min)
        // bounds.x.max = max(bounds.x.max, inner.x.max)
        // bounds.y.min = min(bounds.y.min, inner.y.min)
        // bounds.y.max = max(bounds.y.max, inner.y.max)
        // Contract to outer
        bounds.x.min = (0, math_1.max)(bounds.x.min, outer.x.min);
        bounds.x.max = (0, math_1.min)(bounds.x.max, outer.x.max);
        bounds.y.min = (0, math_1.max)(bounds.y.min, outer.y.min);
        bounds.y.max = (0, math_1.min)(bounds.y.max, outer.y.max);
        // Fix empty bounds
        if (bounds.x.max - bounds.x.min < epsilon) {
            bounds.x.min -= epsilon / 2;
            bounds.x.max += epsilon / 2;
        }
        if (bounds.y.max - bounds.y.min < epsilon) {
            bounds.y.min -= epsilon / 2;
            bounds.y.max += epsilon / 2;
        }
        return bounds;
    }
    exports.cleanBounds = cleanBounds;
    /** Squares the aspect ratio of the data bounds with the screen */
    function squareBounds(bounds, width, height) {
        var dataRatio = (bounds.x.max - bounds.x.min) / (bounds.y.max - bounds.y.min);
        var chartRatio = width / height;
        if (dataRatio < chartRatio) {
            return {
                x: {
                    min: 0,
                    max: width * (bounds.y.max - bounds.y.min) / height
                },
                y: {
                    min: bounds.y.min,
                    max: bounds.y.max
                }
            };
        }
        else {
            return {
                x: {
                    min: 0,
                    max: bounds.x.max
                },
                y: {
                    min: bounds.y.max - height * (bounds.x.max - bounds.x.min) / width,
                    max: bounds.y.max
                }
            };
        }
    }
    exports.squareBounds = squareBounds;
});
//# sourceMappingURL=/assets/javascripts/util/bounds.js.map;
